import { render, staticRenderFns } from "./EscalationItem.vue?vue&type=template&id=59aaa8e1&scoped=true"
import script from "./EscalationItem.vue?vue&type=script&lang=js"
export * from "./EscalationItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59aaa8e1",
  null
  
)

export default component.exports